export const CX = "PdfMenu";
